import type { NavItem } from "../../app/sidebar"

export interface IntegrationNavVisibility {
	isAdmin: boolean
	plainConnected: boolean
	intercomConnected: boolean
	cursorConnected: boolean
	sentryAvailable: boolean
}

export const PLAIN_SETTINGS_HREF = "/settings/integrations/plain"
export const INTERCOM_SETTINGS_HREF = "/settings/integrations/intercom"
export const CURSOR_SETTINGS_HREF = "/settings/integrations/cursor"
export const POSTGRES_SETTINGS_HREF = "/settings/integrations/postgres"
export const SENTRY_SETTINGS_HREF = "/settings/integrations/sentry"

// Plain is inbound-only and Cursor is no longer offered, so both stay hidden
// unless the workspace already uses them. Intercom is the migrator, which a
// workspace needs to find before it has connected anything. PostgreSQL is
// admin-only: the connection string and query whitelist need elevated trust.
// Keyed by href, not by title: a renamed nav label would silently unhide one.
export function visibleIntegrationNavItems(
	items: NavItem[],
	visibility: IntegrationNavVisibility,
): NavItem[] {
	return items.filter((item) => {
		if (item.href === PLAIN_SETTINGS_HREF) return visibility.plainConnected
		if (item.href === CURSOR_SETTINGS_HREF) return visibility.cursorConnected
		if (item.href === POSTGRES_SETTINGS_HREF) return visibility.isAdmin
		if (item.href === SENTRY_SETTINGS_HREF) return visibility.sentryAvailable
		return true
	})
}

// cmd+k builds its Settings group from every nav item, so Cursor needs the same
// gate there as in the sidebar.
export function visibleSettingsNavItems(
	items: NavItem[],
	visibility: { cursorConnected: boolean; sentryAvailable: boolean },
): NavItem[] {
	return items.filter((item) => {
		if (item.href === CURSOR_SETTINGS_HREF) return visibility.cursorConnected
		if (item.href === SENTRY_SETTINGS_HREF) return visibility.sentryAvailable
		return true
	})
}
